// ==========================================
// ORDER HANDLER — Hardcover + PDF Buy Flow
// Uploads face image to R2, then adds to
// Shopify cart with personalization props.
// ==========================================

(function () {
  'use strict';

  const formSection =
    document.querySelector('[data-section-type="eq-personalization-form"]') ||
    document.querySelector('[data-section-type="sa-personalization-form"]');

  if (!formSection) return;

  const HARDCOVER_VARIANT_ID  = formSection.dataset.hardcoverVariantId;
  const PDF_VARIANT_ID        = formSection.dataset.pdfVariantId;
  const PAPERBACK_VARIANT_ID  = formSection.dataset.paperbackVariantId;
  const FACE_UPLOAD_WEBHOOK   = formSection.dataset.faceUploadWebhook;

  // ── Helpers ───────────────────────────────────────────────────────────────

  function setBtn(btn, text, disabled) {
    btn.textContent = text;
    btn.disabled    = disabled;
  }

  // Upload face base64 to R2 via n8n; returns a long-lived URL.
  async function uploadFaceImage(dataUrl) {
    if (!FACE_UPLOAD_WEBHOOK) return dataUrl; // no webhook configured → pass through
    const resp = await fetch(FACE_UPLOAD_WEBHOOK, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ face_base64: dataUrl })
    });
    if (!resp.ok) throw new Error('Face upload failed: ' + resp.status);
    const data = await resp.json();
    if (!data.image_url) throw new Error('Face upload returned no URL');
    return data.image_url;
  }

  // Add one item to Shopify cart with personalization as line item properties.
  async function addToCart(variantId, productType, pData, faceUrl) {


        // Confirm binding from the actual Shopify variant.
    const bindingByVariant = {
      '50802335809822': 'paperback', // EQ paperback
      '50802336629022': 'paperback', // SA paperback
      '59767778869534': 'hardcover', // SA hardcover
    };

    const actualProductType =
      bindingByVariant[String(variantId)] || productType;



    const properties = {
      // Visible to customer in cart / order confirmation
      'First Name':     pData.first_name,
      'Gender':         pData.gender === 'M' ? 'Boy' : 'Girl',
      // 'Body Build':     { S: 'Slim', A: 'Average', C: 'Fuller' }[pData.body_structure] || pData.body_structure,
      // 'Skin Tone':      { W: 'Light', A: 'Fair', B: 'Brown', D: 'Dark' }[pData.skin_tone] || pData.skin_tone,

      // Hidden fields (underscore prefix hides them on Shopify storefront)
      '_story_type':    pData.story_type,
      '_gender':        pData.gender,
      '_height':        pData.height || 'S',
      // '_body':          pData.body_structure,
      // '_skin':          pData.skin_tone,
      '_product_type': actualProductType,       // 'hardcover' | 'pdf'
      '_face_image_url': faceUrl,
    };

    const resp = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties }] })
    });

    if (!resp.ok) {
      const err = await resp.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart (' + resp.status + ')');
    }
    return resp.json();
  }

  // ── Core click handler ────────────────────────────────────────────────────

  async function handleOrderClick(variantId, productType, btn) {
    const raw = sessionStorage.getItem('personalization_data');
    if (!raw) {
      alert('Please generate your preview first, then order.');
      return;
    }

    const pData = JSON.parse(raw);
    const originalText = btn.textContent;

    // ── Disable ALL order buttons ──
    const allOrderBtns = document.querySelectorAll(
      '#order-hardcover-btn, #order-paperback-btn, #order-pdf-btn'
    );
    allOrderBtns.forEach(b => { b.disabled = true; });

    setBtn(btn, 'Uploading photo…', true);

    try {
      let faceUrl = pData.face_image_url || '';

      if (FACE_UPLOAD_WEBHOOK && faceUrl.startsWith('data:')) {
        faceUrl = await uploadFaceImage(faceUrl);
        pData.face_image_url = faceUrl;
        sessionStorage.setItem('personalization_data', JSON.stringify(pData));
      }

      setBtn(btn, 'Adding to cart…', true);
      await addToCart(variantId, productType, pData, faceUrl);

      window.location.href = '/cart';

    } catch (err) {
      console.error('Order error:', err);
      alert('Something went wrong: ' + err.message + '\nPlease try again.');

      // ── Re-enable ALL buttons on error ──
      allOrderBtns.forEach(b => { b.disabled = false; });
      setBtn(btn, originalText, false);
    }
  }

  // ── Wire up buttons ───────────────────────────────────────────────────────

  const hardcoverBtn = document.getElementById('order-hardcover-btn');
  var paperbackBtn  = document.getElementById('order-paperback-btn');
  const pdfBtn       = document.getElementById('order-pdf-btn');

  if (hardcoverBtn && HARDCOVER_VARIANT_ID) {
    hardcoverBtn.addEventListener('click', () =>
      handleOrderClick(HARDCOVER_VARIANT_ID, 'hardcover', hardcoverBtn)
    );
  }
  if (paperbackBtn && PAPERBACK_VARIANT_ID) {
  paperbackBtn.addEventListener('click', () =>
    handleOrderClick(PAPERBACK_VARIANT_ID, 'paperback', paperbackBtn)
  );
}

  if (pdfBtn && PDF_VARIANT_ID) {
    pdfBtn.addEventListener('click', () =>
      handleOrderClick(PDF_VARIANT_ID, 'pdf', pdfBtn)
    );
  }

  // ── Guard: disable order buttons until preview is generated ──────────────
  // Re-enable them when #preview-container becomes visible.
  function refreshOrderBtns(visible) {
    [hardcoverBtn, paperbackBtn, pdfBtn].forEach(b => {
      if (b) b.disabled = !visible;
    });
  }

  const previewContainer = document.getElementById('preview-container');
  if (previewContainer) {
    // Start disabled
    refreshOrderBtns(false);
    new MutationObserver(() => {
      refreshOrderBtns(!previewContainer.classList.contains('hidden'));
    }).observe(previewContainer, { attributes: true, attributeFilter: ['class'] });
  }
})();
